import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectGlobalOrgRegistrationsListItems } from "../../../../redux/global-org-registrations/selector";
import { globalOrgRegistrations } from "../../../../redux/global-org-registrations/action";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { globalDodAgencyMapping } from "../../../../redux/dod-agency-mapping/action";
import { selectGlobalDodAgencyMappingListItems } from "../../../../redux/dod-agency-mapping/selector";



const GlobalDODCloudMappings = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const globalDODCloudMappingItems = useSelector(selectGlobalDodAgencyMappingListItems)
    localStorage.removeItem('storageKey')
    const [
        columnDefs,
        setColumnDefs
    ] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'PartnerGlobalDBARegistryName', headerName: 'Partner Global DBA Registry Name' },
            { field: 'InternalGlobalDBARegistryName', headerName: 'Internal Global DBA Registry Name' },
         { field: 'IsActive', headerName: 'Is Active', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
          { field: 'IsUpstreamProvider', headerName: 'Upstream Provider', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
            { field: 'IsChannelProvider', headerName: 'Channel Provider', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },

            { field: 'GlobalDODProgramParticipantName', headerName: 'Global DOD Program Participant Network' },
            { field: 'GlobalDODProgramParticipantType', headerName: 'Global DOD Program Participant Type' },

        ]);
    }
    const handleDBNPRegistry = async (data: any) => {
        navigate(`/dbn/global-dbnp-registrations/${data.GlobalDBNPRegistryId}`)
    }
    const handleCreateExisting = () => {
    dispatch(globalDodAgencyMapping.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dod-agency-mappings/create-existing`,
        entity: 'globalDODCloudMapping',
        jsonData: {
            Context: {},
            Records: [
                {  }
            ]
        }
    })).then(() => {
        fetchglobalDodAgencyMappings();
    });
};
    const fetchglobalDodAgencyMappings = () => {
        dispatch(globalDodAgencyMapping.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dod-agency-mappings/fetch`, entity: 'globalDODCloudMapping', jsonData: {

                "Context": {},
                "Records": [
                    {

                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDODAgencyMappingId",
                    "SortOrder": "desc",
                }

            }
        }))
    }
    const handleAdd = () => {
        navigate(`${0}`)
    }
    const handleEdit = (data: any) => {
        navigate(`${data.GlobalDODAgencyMappingId}`)
    }

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }

        dispatch(globalDodAgencyMapping.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dod-agency-mappings/fetch`, entity: 'GlobalDodAgencyMapping', jsonData: {

                "Context": {},
                "Records": [
                    {

                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDODAgencyMappingId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }


            }
        }))
    }

    const handleReloadData = () => {
        dispatch(globalDodAgencyMapping.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dod-agency-mappings/fetch`, entity: 'GlobalDodAgencyMapping', jsonData: {
                "Context": {},
                "Records": [
                    {

                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDODAgencyMappingId",
                    "SortOrder": "desc",
                }


            }
        }))
    }
    const filterTypes = [{
        name: 'Text', value: "text"
    },
    {
        name: 'Number', value: "number"
    },
    {
        name: 'CheckBox', value: "checkbox"
    },
    {
        name: 'Date', value: "date"
    }
    ]
    const additionButtons: any = [
    {
        svg: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                width="24"
                height="24"
            >
                <title>Reload</title>
                <path
                    d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        callback: () => handleReloadData(),
    },
    // {
    //     name: "Create Existing",
    //     callback: () => handleCreateExisting(),
    // },
];

    useEffect(() => {
        createColumnDefs()
        fetchglobalDodAgencyMappings()
    }, [pageData, pageSize])

    const handleDelete = (data: any) => {
        dispatch(globalDodAgencyMapping.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/delete`,
            entity: 'globalDodAgencyMapping',
            jsonData: {
                Records: [
                    {

                        Id: data?.GlobalDODAgencyMappingId
                    }

                ]
            }
        })).then(() => {
            dispatch(globalDodAgencyMapping.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dod-agency-mappings/fetch`, entity: 'globalDODCloudMapping', jsonData: {

                    "Context": {},
                    "Records": [
                        {

                        }
                    ],
                    "Pagination": {
                        "PageNumber": pageData,
                        "PageSize": pageSize,
                        "SortField": "GlobalDODAgencyMappingId",
                        "SortOrder": "desc",
                    }

                }
            }))
        });
    }
    return (
        <>
            {globalDODCloudMappingItems?.isLoading ? <PageLoader /> :
                <Table columnData={columnDefs} additionButtons={additionButtons} enableFilter={true}
                    filterTypeLists={filterTypes}
                    onSearch={handleSearch} rowData={globalDODCloudMappingItems?.result?.items} setPageData={setPageData}
                    paginationData={globalDODCloudMappingItems?.result?.pagination}
                    onEdit={handleEdit} setPageSize={setPageSize} headingName="Global DOD Agency Mappings" />
            }
        </>
    );
};

export default GlobalDODCloudMappings;


